/* eslint-disable max-len */
import React from 'react';

type Props = {
  color?: string;
  className?: string;
};

const ArrowsLine: React.FC<Props> = ({ color = 'white', className }) => {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M15.5207 4C15.3863 4 15.2488 4.05312 15.1457 4.15625C14.9394 4.3625 14.9394 4.7 15.1457 4.90625L22.205 11.9656L15.2488 18.9219C15.0425 19.1281 15.0425 19.4656 15.2488 19.6719C15.455 19.8781 15.7925 19.8781 15.9988 19.6719L23.3332 12.3406C23.5394 12.1344 23.5394 11.7969 23.3332 11.5906L15.8988 4.15625C15.7925 4.05 15.6582 4 15.5207 4Z'
        fill={color}
      />

      <path
        opacity='0.6'
        d='M11.0236 4C10.8892 4 10.7517 4.05312 10.6486 4.15625C10.4423 4.3625 10.4423 4.7 10.6486 4.90625L17.708 11.9656L10.7517 18.9219C10.5455 19.1281 10.5455 19.4656 10.7517 19.6719C10.958 19.8781 11.2955 19.8781 11.5017 19.6719L18.8361 12.3406C19.0423 12.1344 19.0423 11.7969 18.8361 11.5906L11.4017 4.15625C11.2955 4.05 11.1611 4 11.0236 4Z'
        fill={color}
      />

      <path
        opacity='0.2'
        d='M2.02972 4C1.89534 4 1.75782 4.05312 1.6547 4.15625C1.44845 4.3625 1.44845 4.7 1.6547 4.90625L8.71407 11.9656L1.75782 18.9219C1.55157 19.1281 1.55157 19.4656 1.75782 19.6719C1.96407 19.8781 2.30157 19.8781 2.50782 19.6719L9.8422 12.3406C10.0484 12.1344 10.0484 11.7969 9.8422 11.5906L2.40782 4.15625C2.30158 4.05 2.16721 4 2.02972 4Z'
        fill={color}
      />

      <path
        opacity='0.4'
        d='M6.52654 4C6.39217 4 6.25465 4.05312 6.15153 4.15625C5.94528 4.3625 5.94528 4.7 6.15153 4.90625L13.2109 11.9656L6.25465 18.9219C6.0484 19.1281 6.0484 19.4656 6.25465 19.6719C6.4609 19.8781 6.7984 19.8781 7.00465 19.6719L14.339 12.3406C14.5453 12.1344 14.5453 11.7969 14.339 11.5906L6.90465 4.15625C6.7984 4.05 6.66404 4 6.52654 4Z'
        fill={color}
      />
    </svg>
  );
};

export default ArrowsLine;
